import _ from 'lodash';

import { Types } from 'app/actions/company-admin/page-wallet';
import utils from 'app/reducers/utils';

const initialState = {
  loadPending: true,
  fetchBasPending: false,
  baIds: [],
  deleteBaPending: false,
  fetchCcsPending: false,
  deleteCcPending: false,
  deleteConflictId: null, // id of a payment method that failed a deletion attempt due to it being in use as a default
  ccIds: [],
  createCcPending: false,
  createCcValidations: false,
  assignPmType: null,
  assignPmId: null,
  assignPmPending: false,
  assignPmError: false,
  showBaId: null,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, action) => {
    return {...state,
      deleteConflictId: null,
      loadPending: true,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, action) => {
    return {...state,
      loadPending: false,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, action) => {
    return {...state,
      loadPending: false,
    };
  },

  [`${Types.FETCH_CCS}_PENDING`]: (state, action) => {
    return {...state,
      fetchCcsPending: true,
      ccIds: [],
    };
  },
  [`${Types.FETCH_CCS}_RESOLVED`]: (state, action) => {
    const ccIds = action.result.creditCards.map(cc => cc.id);
    return {...state,
      fetchCcsPending: false,
      ccIds,
    };
  },
  [`${Types.FETCH_CCS}_REJECTED`]: (state, action) => {
    return {...state,
      fetchCcsPending: false,
    };
  },

  [`${Types.DELETE_CC}_PENDING`]: (state, action) => {
    return {...state,
      deleteConflictId: null,
      deleteCcPending: true,
    };
  },
  [`${Types.DELETE_CC}_RESOLVED`]: (state, action) => {
    return {...state,
      deleteCcPending: false,
    };
  },
  [`${Types.DELETE_CC}_REJECTED`]: (state, {creditCardId, ...action}) => {
    const isConflict = _.get(action, 'error.response.status') === 409;
    return {...state,
      deleteCcPending: false,
      deleteConflictId: isConflict ? creditCardId : null,
    };
  },

  [`${Types.DELETE_BA}_PENDING`]: (state, action) => {
    return {...state,
      deleteConflictId: null,
      deleteBaPending: true,
    };
  },
  [`${Types.DELETE_BA}_RESOLVED`]: (state, action) => {
    return {...state,
      deleteBaPending: false,
    };
  },
  [`${Types.DELETE_BA}_REJECTED`]: (state, {bankAccountId, ...action}) => {
    const isConflict = _.get(action, 'error.response.status') === 409;
    return {...state,
      deleteBaPending: false,
      deleteConflictId: isConflict ? bankAccountId : null,
    };
  },

  [`${Types.FETCH_BAS}_PENDING`]: (state, action) => {
    return {...state,
      fetchBasPending: true,
      baIds: [],
    };
  },
  [`${Types.FETCH_BAS}_RESOLVED`]: (state, action) => {
    const baIds = action.result.bankAccounts.map(ba => ba.id);
    return {...state,
      fetchBasPending: false,
      baIds,
    };
  },
  [`${Types.FETCH_BAS}_REJECTED`]: (state, action) => {
    return {...state,
      fetchBasPending: false,
    };
  },

  [`${Types.CREATE_CC}_PENDING`]: (state, action) => {
    return {...state,
      createCcPending: true,
      createCcValidations: null,
    };
  },
  [`${Types.CREATE_CC}_RESOLVED`]: (state, action) => {
    return {...state,
      createCcPending: false,
      createCcValidations: null,
    };
  },
  [`${Types.CREATE_CC}_REJECTED`]: (state, {employeeId, error}) => {
    const validations = _.get(error, 'response.data.error.validations', null);
    return {...state,
      createCcPending: false,
      createCcValidations: validations,
    };
  },

  [Types.SHOW_ASSIGN_PM]: (state, action) => {
    return {...state,
      assignPmId: action.pmId,
      assignPmType: action.pmType,
      assignPmPending: false,
      assignPmError: false,
    };
  },
  [Types.CLOSE_ASSIGN_PM]: (state, action) => {
    return {...state,
      assignPmId: null,
      assignPmType: null,
      showBaId: null,
    };
  },

  [`${Types.SUBMIT_ASSIGN_PM}_PENDING`]: (state, action) => {
    return {...state,
      assignPmPending: true,
      assignPmError: false,
    };
  },
  [`${Types.SUBMIT_ASSIGN_PM}_RESOLVED`]: (state, action) => {
    return {...state,
      assignPmId: null,
      assignPmType: null,
      assignPmPending: false,
      showBaId: null,
    };
  },
  [`${Types.SUBMIT_ASSIGN_PM}_REJECTED`]: (state, {employeeId, error}) => {
    return {...state,
      assignPmPending: false,
      assignPmError: true,
    };
  },

  [Types.SHOW_BANK_ACCOUNT]: (state, action) => {
    return {...state,
      showBaId: action.baId || null,
    };
  },

});

export default reducer;
